import { useEffect, useRef, useCallback } from 'react';

/**
 * @desc 防抖函数 hook
 * @param callback (...args: any[]) => void
 * @param delay number
 * @param dep any[]
 * @returns (...args: any[]) => void
 */
export function useDebounce(callback: (...args: any[]) => void, delay: number, dep: any[] = []) {
    const { current } = useRef<{
        callback: (...args: any[]) => void;
        timer: any;
    }>({ callback, timer: null });

    useEffect(() => {
        current.callback = callback;
    }, [callback]);

    return useCallback((...args: any[]) => {
        if (current.timer) {
            clearTimeout(current.timer);
        }
        current.timer = setTimeout(() => {
            current.callback(...args);
        }, delay);
    }, dep);
}
